<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-tw">
                <div class="c-td is-1">
                    <strong>{{ months[data.month] }} {{ data.year }}</strong>
                </div>
                <div class="c-td is-2">
                    <div class="typo-label">Obrót ogółem</div>
                    <a-status-text
                        class="justify-content-start"
                        :value="+data.total_rev.toFixed()"
                        :goal="totalGoal + 0.01"
                        :displayGoal="totalGoal"
                        :isSuccess="totalGoalReached"
                    />
                </div>
                <div class="c-td is-3">
                    <div class="typo-label">Obrót piwo</div>
                    <a-status-text
                        class="justify-content-start"
                        :value="+data.beer_rev.toFixed()"
                        :goal="beerGoal + 0.01"
                        :displayGoal="beerGoal"
                        :isSuccess="beerGoalReached"
                    />
                </div>
                <div class="c-td is-4">
                    <div class="typo-label">Sprzedaż na kodach EAN</div>
                    <a-status-text
                        class="justify-content-start"
                        :value="+data.full_ean_rev.toFixed()"
                        :goal="data.total_rev * 0.6"
                        :displayGoal="+data.total_rev.toFixed()"
                        :showProgress="true"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import months from '@/dictionaries/months'
export default {
    data() {
        return {
            totalGoal: 100000,
            beerGoal: 5000
        }
    },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        months() {
            return months
        },
        totalGoalReached() {
            return this.data.total_rev > this.totalGoal
        },
        beerGoalReached() {
            return this.data.beer_rev > this.beerGoal
        }
    }
}
</script>
